<template>
    <div class="max-width-content">
        <!-- <trashed-message v-if="place.deleted_at" class="mb-6">
            This place has been deleted.
        </trashed-message> -->

        <div class="flex items-center justify-between">
            <breadcrumbs>
                <inertia-link :href="route('admin.places.index')">Plaatsen</inertia-link>
                <i class="fad fa-chevron-right"></i>
                {{ place.name | truncate(35) }}
            </breadcrumbs>

            <div v-if="!place.deleted_at">
                <link-button :href="route('admin.places.edit', place.id)" icon="pencil" class="bg-white">Wijzig</link-button>
                <!-- <link-button method="delete" :href="route('admin.places.destroy', place.id)" icon="trash" class="bg-white hover:bg-red-600 hover:text-white">Verwijder</link-button> -->
            </div>
        </div>

                <h1 class="text-5xl text-teal-800 mr-1 leading-tight mt-3">{{ place.name }}</h1>

                <div class="mt-5 bg-white px-5 py-3 rounded-lg">
                    <h2 class="text-xl font-bold">SEO teksten</h2>

                    <div class="mt-3">
                        <h3 class="text-base font-bold">Meta description:</h3>
                        <div v-if="place.seo_description" v-html="place.seo_description"></div>
                        <div v-else>Er is nog geen SEO meta description.</div>
                    </div>

                    <div class="mt-3">
                        <h3 class="text-base font-bold">SEO tekst boven:</h3>
                        <div v-if="place.seotext1" v-html="place.seotext1"></div>
                        <div v-else>Er is nog geen SEO tekst voor boven.</div>
                    </div>

                    <div class="mt-5">
                        <h3 class="text-base font-bold">SEO tekst onder:</h3>
                        <div v-if="place.seotext2" v-html="place.seotext2"></div>
                        <div v-else>Er is nog geen SEO tekst voor onder.</div>
                    </div>
                </div>
                
            </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import LinkButton from "@/admin/Shared/LinkButton";

export default {
    metaInfo: { title: "Plaatsen" },

    layout: Layout,

    mixins: [Helpers],

    components: { Breadcrumbs, LinkButton },

    props: {
        place: {
            Type: Object
        }
    },
    data() {
        return {};
    },
    methods: {}
};
</script>
